import Address from "@/classes/global/Address";
import ContactDetail from "@/classes/bookings/ContactDetail";

export default class PickStockConsignee extends Address {
    constructor() {

        super();

    }
}
